import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { User, Globe } from "lucide-react";
import type { TranslateFn } from "@/types";

interface PersonalInfoFieldsProps {
  name: string;
  contactNumber: string;
  preferredLanguage?: string;
  onChange: (field: string, value: string) => void;
  t: TranslateFn;
}

export const PersonalInfoFields = ({ name, contactNumber, preferredLanguage = "en", onChange, t }: PersonalInfoFieldsProps) => (
  <div className="space-y-4">
    <h3 className="font-semibold text-lg flex items-center gap-2">
      <User className="h-5 w-5" />
      {t('booking.personalInfo')}
    </h3>
    <div>
      <Label htmlFor="name">{t('booking.name')} *</Label>
      <Input
        id="name"
        data-testid="input-name"
        value={name}
        onChange={(e) => onChange("name", e.target.value)}
        placeholder={t('booking.namePlaceholder')}
        required
      />
    </div>
    <div>
      <Label htmlFor="contact_number">{t('booking.contactNumber')} *</Label>
      <Input
        id="contact_number"
        data-testid="input-contact-number"
        value={contactNumber}
        onChange={(e) => onChange("contact_number", e.target.value)}
        placeholder={t('booking.contactPlaceholder')}
        required
      />
    </div>
    <div>
      <Label htmlFor="preferred_language" className="flex items-center gap-1.5">
        <Globe className="h-4 w-4" />
        {t('booking.preferredLanguage')} *
      </Label>
      <Select value={preferredLanguage} onValueChange={(val) => onChange("preferred_language", val)}>
        <SelectTrigger data-testid="select-preferred-language">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">English</SelectItem>
          <SelectItem value="th">ไทย (Thai)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
);
